<fieldset cdxFieldset [formGroup]="formGroup">
	<div>
		<form-flexible-selection-tile
			class="vertical"
			inputId="{{ date }}~{{ slot?.id }}"
			attr.data-cy="timeslot-flexible"
			attr.data-ft="fullstory-flexible-delivery"
			inputValue="{{ date }}~{{ slot?.id }}~{{ slot?.itemsLimit }}"
			i18n="@@selection-time"
			[formControlName]="controlName"
			[successIcon]="false"
			[label]="label"
			[hasChevron]="hasChevron"
		/>
	</div>
</fieldset>
